import React from 'react';
import '../css/skills.css';

const Skills = () => {
  return (
    <section id="skills" className="skills-section">
      <h2>Skills</h2>
      <ul>
        <li>Cloud: Azure, AWS</li>
        <li>Scripting: Bash, Windows Batch, Azure CLI</li>
        <li>DevOps Tools: Kubernetes, Docker, Helm</li>
        <li>Monitoring: ELK, Dynatrace</li>
      </ul>
    </section>
  );
};

export default Skills;
